import { MutationFunctionOptions, gql, useMutation } from '@apollo/client';
import { AudienceList } from 'modules/domains/campaign';
import { CampaignEditorFormState } from '../types';

type ListIds = AudienceList['id'][];

export const getUpdateCampaignAudienceMutationPayload = (
  campaignId: number,
  formValues: {
    listIds?: ListIds;
    suppressionListIds?: ListIds;
  },
) => {
  const { listIds, suppressionListIds } = formValues;

  return {
    campaignId,
    fields: {
      ...(!!listIds && { listIds }),
      ...(!!suppressionListIds && { suppressionListIds }),
    },
  };
};

export const getUpdateCampaignMutationPayload = (
  campaignId: number,
  formValues: {
    campaignAlertsEnabled?: CampaignEditorFormState['campaignAlertsEnabled'];
  },
) => {
  const { campaignAlertsEnabled } = formValues;

  return {
    campaignId,
    fields: {
      campaignAlertsEnabled: !!campaignAlertsEnabled,
    },
  };
};

export const updateCampaignMutation = gql`
  mutation updateCampaign($campaignId: Long!, $fields: UpdateCampaignFieldsInput!) {
    updateCampaign(campaignId: $campaignId, fields: $fields) {
      campaignAlertsEnabled
      lists {
        id
      }
      suppressionLists {
        id
      }
    }
  }
`;

export type UpdateCampaignVariables = {
  campaignId: number;
  fields: {
    campaignAlertsEnabled?: CampaignEditorFormState['campaignAlertsEnabled'];
    listIds?: ListIds;
    suppressionListIds?: ListIds;
  };
};
export type UpdateCampaignResponse = {
  updateCampaign: {
    campaignAlertsEnabled: CampaignEditorFormState['campaignAlertsEnabled'];
    lists: ListIds;
    suppressionLists: ListIds;
  };
};

export const useUpdateCampaignMutation = () => {
  const [mutate, { loading: isLoading, data, error }] = useMutation<
    UpdateCampaignResponse,
    UpdateCampaignVariables
  >(updateCampaignMutation);

  const updateCampaign = (
    options?: MutationFunctionOptions<UpdateCampaignResponse, UpdateCampaignVariables>,
  ) => mutate(options);

  return {
    data,
    error,
    isLoading,
    updateCampaign,
  };
};
